<template>
  <div class="news_wrap">
    <div class="news_content">
      <div class="news_info">
        <a
          href="javascript:;"
          class="btn_back db"
          @click="$router.push('/mobile')"
          >返回</a
        >
      </div>
      <div class="news_content_wrap">
        <div class="news_tab">
          <a
            href="javascript:;"
            :class="newsType == 0 ? 'cur' : ''"
            @click="changeNewsType(0)"
            >最新</a
          >
          <a
            href="javascript:;"
            :class="newsType == 1 ? 'cur' : ''"
            @click="changeNewsType(1)"
            >新闻</a
          >
          <a
            href="javascript:;"
            :class="newsType == 2 ? 'cur' : ''"
            @click="changeNewsType(2)"
            >公告</a
          >
          <a
            href="javascript:;"
            :class="newsType == 3 ? 'cur' : ''"
            @click="changeNewsType(3)"
            >活动</a
          >
        </div>
        <ul class="news_list" v-if="newsList2">
          <template v-for="(item, index) in newsList2" :key="index">
            <li @click="$router.push('/news?id=' + item.id)">
              <p class="news_time">{{ formatDate(item.start_time) }}</p>
              <p class="news_txt">
                <em>{{ newsTypeText[item.type] }}</em
                ><span>{{ item.title }}</span>
              </p>
            </li>
          </template>
        </ul>
        <div class="news_none" v-else>暂无更多内容</div>
      </div>
    </div>
    <!-- 导航 -->
    <div class="top_box">
      <a href="javascript:;" class="top_logo"></a>
      <div class="tright_icon">
        <a
          href="javascript:;"
          :class="bgmState ? 'btn_bgm play' : 'btn_bgm'"
          @click="playBgm()"
        ></a>
        <a href="javascript:;" class="btn_zhuan" @click="showShare()"></a>
      </div>
    </div>
    <!-- 分享浮层 -->
    <div class="share_pop" @click="closeShare()" v-if="sharePop">
      <img src="/img/m/share_fc.png" alt="" />
    </div>
    <!-- bgm -->
    <audio src="media/bgm.mp3" loop preload="auto" autoplay class="bgm"></audio>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/mousewheel";
import SwiperCore, { Mousewheel } from "swiper";
import { useRoute, useRouter } from "vue-router"; // 导入 useRouter
import { formatDate } from "@/utils/formatDate"; // 导入时间格式化函数
import { getCode, makeReservation, getNewsList, getNewsDetail } from "@/api"; // 导入api
import { toast } from "vue3-toastify"; // 引入toast组件

// 设置html和body的高度为auto
document.documentElement.style.height = "auto";
document.body.style.height = "auto";

function showToast(msg) {
  toast.info(msg);
}

// 双端适配
const router = useRouter(); // 获取路由实例
const route = useRoute();
const detailId = Number(route.query.id); // 获取路由参数
const isPt = () => {
  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  if (isMobile) {
    router.push("/mobile/list");
  } else {
    router.push("/list");
  }
};
onMounted(() => {
  isPt();
  setTimeout(() => {
    document.dispatchEvent(new Event("render-event"));
  });
  window.addEventListener("resize", isPt);
});
onUnmounted(() => {
  window.removeEventListener("resize", isPt);
});

// 切换新闻类型
const newsList2 = ref([]); // 右侧新闻初始为空数组
onMounted(async () => {
  try {
    // 获取新闻列表
    const res = await getNewsList(1, 15);
    newsList2.value = res.list;
  } catch (e) {
    console.warn(e);
  }
});
const newsType = ref(0); // 定义一个ref来保存当前新闻类型
const newsTypeText = ["最新", "新闻", "公告", "活动"]; // 定义新闻类型文本
const changeNewsType = (type) => {
  //切换新闻类型，只显示对应type的新闻
  newsType.value = type;
  //重新请求新闻列表
  getNewsList(1, 15, type).then((res) => {
    // console.log("当前获取的type内容：",res)
    newsList2.value = res.list;
    // if(type==0){
    //     newsList2.value = res.list;
    // }else{
    //     // console.log(res.list.filter(item => item.type === type));
    //     newsList2.value = res.list.filter(item => item.type === type);
    // }
  });
};

// bgm播放
const bgmState = ref(false); // 定义一个ref来保存bgm播放状态
const playBgm = () => {
  if (bgmState.value) {
    document.querySelector(".bgm").pause();
    bgmState.value = false;
  } else {
    document.querySelector(".bgm").play();
    bgmState.value = true;
  }
};
document.body.addEventListener(
  "click",
  () => {
    document.querySelector(".bgm").play();
    bgmState.value = true;
  },
  { once: true }
);

// 点击弹出分享指引
const sharePop = ref(false);
const showShare = () => {
  sharePop.value = true;
};
const closeShare = () => {
  sharePop.value = false;
};
</script>

<style lang="scss" scoped>
@use "./m" as m;
</style>
